import { Footer, Header } from 'darrius';
import { HeadContent } from '../../components';

import { type ISignupMGMTemplateProps } from './@interfaces';
import {
  About,
  BannerDownloadApp,
  Bonus,
  Hero,
  Onboarding,
  Promotion,
  Services,
  Testimonial,
} from './partials';

export default function SignupMGMTemplate({
  staticContent,
  meta,
  promotion,
  onboarding,
  bonus,
  services,
}: ISignupMGMTemplateProps) {
  const { footerContent } = staticContent;

  return (
    <>
      <HeadContent
        metaTitle={meta.title}
        slug=""
        metaDescription={meta.description}
        type="mgm:signup"
      />

      <Header.Root>
        <Header.NavMenu>
          <Header.Link
            text="Baixar o aplicativo"
            link="https://www.getninjas.com.br/download/app"
          />
        </Header.NavMenu>
      </Header.Root>

      <main>
        <Hero />
        <About />
        <Bonus {...bonus} />
        <Services {...services} />
        <Testimonial />
        <Onboarding data={onboarding} />
        <BannerDownloadApp />
        <Promotion {...promotion} />
      </main>

      <Footer data={footerContent} />
    </>
  );
}
